import { FC, forwardRef, useEffect, useState } from "react";
import ModalComponent from "./modal.component";
import styles from "./ContactDetail.module.scss";
import { Box, Button, Tab, Tabs, TextareaAutosize } from "@mui/material";
import { PageHeading } from "./page-heading.component";
import InputTextField from "./text-field.component";
import {
    EstimateClass
  } from "../Models/estimate.model";
import {
  DropdownInput,
  IOption,
} from "./dropdown-input-component";
import {
  ContactClass,
  ContactModel,
  ContactValidationSchema,
} from "../Models/contact.model";
import { PrimaryButton } from "./primary-button.component";
import { ContactService } from "../Services/contact.service";
import { useNavigate, useParams } from "react-router-dom";
import {
  DatePickerComponent,
  DatePickerInput,
  DatePickerRenderInput,
} from "./date-picker.component";
import { useLoading } from "../Shared/services/loading-context";
import { useSnackbar } from "notistack";
import { useFormik } from "formik";
import * as yup from "yup";

export const AddNewContactModal:FC<{isAddNewContactModalOpen: boolean;onSelectCustomer: (data?: any) => void;onClose: () => void;}> = (props: any) => {

  const [isAddNewContactModalOpen, setIsAddNewContactModalOpen] = useState<boolean>(false);
    useEffect(() => {

        if (props.isAddNewContactModalOpen) setIsAddNewContactModalOpen(props.isAddNewContactModalOpen);
        else setIsAddNewContactModalOpen(false);

      }, [props.isAddNewContactModalOpen]);

    const customerModalStyle = {
        border: "none",
        width: "62%",
        height: "70%",
        maxHeight: "100vh",
        maxWidth: "100vw",
        top: "400px",
        left: "950px",
        background: "#FFFFFF",
        boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
        borderRadius: "5px",
        padding: 0,
        overflowY: "auto",
      };
      const [contactField, setContactField] = useState<ContactModel>(
        new ContactClass()
      );
      const { loading, setLoading } = useLoading();
      const { enqueueSnackbar } = useSnackbar();
    
      const typeOfContact: IOption[] = [
        { key: 1, value: "Customer", text: "Customer" },
        { key: 2, value: "Vendor", text: "Vendor" },
        { key: 3, value: "Contractor", text: "Contractor" },
        { key: 4, value: "Broker", text: "Broker" },
        { key: 5, value: "Lead", text: "Lead" },
        { key: 6, value: "Buyer", text: "Buyer" },
        { key: 7, value: "Seller", text: "Seller" },
        { key: 8, value: "Buyer/Seller", text: "Buyer/Seller" },
        { key: 9, value: "Investor", text: "Investor" },
        { key: 10, value: "Agent", text: "Agent" },
        { key: 11, value: "Other", text: "Other" },
      ];
    
      const contactOnOPt: IOption[] = [
        { key: 1, value: "MobileNo", text: "Mobile No" },
        { key: 2, value: "PhoneNo", text: "Phone No" },
      ];
    
      const PromotionOPt: IOption[] = [
        { key: 1, value: "Facebook", text: "Facebook" },
        { key: 2, value: "Instagram", text: "Instagram" },
        { key: 3, value: "LinkedIn", text: "LinkedIn" },
      ];
    
      const fieldVals = (e: any) => {
        formik.handleChange(e);
        const fieldData: any = contactField;
        fieldData[e.target.name] = e.target.value;
        setContactField({ ...fieldData });
      };
    
      const navigate = useNavigate();
    
      const saveData = async () => {
        contactField.sameAddress = false;
        setLoading(true);
        const response = await ContactService.saveDataGetId(contactField);
        setLoading(false);
        if (response.success) {
            setIsAddNewContactModalOpen(false)
            props.onSelectCustomer(response?.data)
            formik.resetForm();
            setContactField(new ContactClass());
        } else
          enqueueSnackbar(response.message ?? "Internal server error", {
            variant: "error",
          });
      };
      const validationSchema = yup.object(ContactValidationSchema);
      const formik = useFormik({
        initialValues: new ContactClass(),
        validationSchema: validationSchema,
        onSubmit: saveData,
      });

    
    return (
    <div>
    <ModalComponent
        title="Select Customer"
        style={customerModalStyle}
        isModalOpen={isAddNewContactModalOpen}
        customHeader={true}
        hideModal={props.onClose}
      >
      <div>
        <div className="page-heading-component d-flex justify-content-between m-3">
          <div className="d-flex justify-content-between title-div">
            <div className="page-header">
              <h2 className="page-heading-text">Add Contact / Customer Fields</h2>
          </div>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <Box className="contact-list-box">
          <div className="basic-info-contactlist">Basic Info</div>
          {/* <pre style={{ width: "200px" }}>{JSON.stringify(formik)}</pre> */}
          <div>
            <DropdownInput
              className="contact-type-dropdown"
              value={contactField.contactType ?? ""}
              label="Contact Type"
              name="contactType"
              options={typeOfContact}
              onChange={fieldVals}
              error={
                formik.touched.contactType && Boolean(formik.errors.contactType)
              }
              helperText={
                formik.touched.contactType && formik.errors.contactType
              }
            />
            <InputTextField
              value={contactField.name ?? ""}
              label="Name"
              name="name"
              onChange={fieldVals}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              // value={formik.values.name}
              // onChange={formik.handleChange}
              // error={formik.touched.name && Boolean(formik.errors.name)}
            />

            <InputTextField
              value={contactField.mobileNo ?? ""}
              label="Mobile No"
              name="mobileNo"
              onChange={fieldVals}
              error={formik.touched.mobileNo && Boolean(formik.errors.mobileNo)}
              helperText={formik.touched.mobileNo && formik.errors.mobileNo}
            />

            <InputTextField
              value={contactField.emailId ?? ""}
              label="Email Id"
              name="emailId"
              onChange={(e) => fieldVals(e)}
            />

            <InputTextField
              value={contactField.businessName ?? ""}
              label="Company/Business Name"
              name="businessName"
              onChange={(e) => fieldVals(e)}
            />

            <InputTextField
              value={contactField.businessType ?? ""}
              label="Business Type"
              name="businessType"
              onChange={(e) => fieldVals(e)}
            />

            <InputTextField
              value={contactField.alternateMobileNo ?? ""}
              label="Alternate Mobile No"
              name="alternateMobileNo"
              onChange={(e) => fieldVals(e)}
            />

            <InputTextField
              value={contactField.phoneNo ?? ""}
              label="Phone No"
              name="phoneNo"
              onChange={(e) => fieldVals(e)}
              error={formik.touched.phoneNo && Boolean(formik.errors.phoneNo)}
              helperText={formik.touched.phoneNo && formik.errors.phoneNo}
            />

            <DropdownInput
              value={contactField.contactOn ?? ""}
              label="Contact On"
              name="contactOn"
              options={contactOnOPt}
              onChange={(e) => fieldVals(e)}
            />

            <InputTextField
              value={contactField.fax ?? ""}
              label="Fax"
              name="fax"
              onChange={(e) => fieldVals(e)}
            />

            <InputTextField
              value={contactField.website ?? ""}
              label="Website"
              name="website"
              onChange={(e) => fieldVals(e)}
            />

            <DatePickerComponent
              key={"Birth Date"}
              label="Birth Date"
              inputFormat="dd/MM/yyyy"
              value={contactField.birthDate}
              onChange={(event: any) =>
                fieldVals({
                  target: { name: "birthDate", value: event },
                })
              }
            />
            <DatePickerComponent
              key={"Marriage Date"}
              label="Marriage Date"
              inputFormat="dd/MM/yyyy"
              value={contactField.marriageDate}
              onChange={(event: any) =>
                fieldVals({
                  target: { name: "marriageDate", value: event },
                })
              }
            />
            <InputTextField
              value={contactField.socialMediaAccountLinks ?? ""}
              label="Social media account links"
              name="socialMediaAccountLinks"
              onChange={(e) => fieldVals(e)}
            />
            <InputTextField
              value={contactField.address ?? ""}
              label="Address"
              name="address"
              onChange={(e) => fieldVals(e)}
            />
            <DropdownInput
              value={contactField.sourceOfPromotion ?? ""}
              label="Source Of Promotion"
              name="sourceOfPromotion"
              options={PromotionOPt}
              onChange={(e) => fieldVals(e)}
              helperText={
                formik.touched.sourceOfPromotion &&
                formik.errors.sourceOfPromotion
              }
              error={
                formik.touched.sourceOfPromotion &&
                Boolean(formik.errors.sourceOfPromotion)
              }
            />
            <DropdownInput
              value={contactField.sourceCampaign ?? ""}
              label="Source Campaign"
              name="sourceCampaign"
              options={contactOnOPt}
              onChange={(e) => fieldVals(e)}
            />
            <InputTextField
              value={contactField.descriptionInformation ?? ""}
              label="Description Information"
              name="descriptionInformation"
              onChange={(e) => fieldVals(e)}
            />
          </div>
        </Box>
        <div>
          <PrimaryButton type="submit" className="contact-save-btn">
            Save
          </PrimaryButton>
        </div>
      </form>
    </div>
      </ModalComponent>
    </div>
  );
};
export default AddNewContactModal;